var map = {
	"./Edit_icon.svg": "27a9",
	"./Fulfilled.svg": "eea1",
	"./Hardware.svg": "d887",
	"./Loan.svg": "8e08",
	"./Logo.svg": "bdd1",
	"./Logo_traction.svg": "2ff7",
	"./Menu.svg": "b4db",
	"./Notification.svg": "4e76",
	"./Path.svg": "cadc",
	"./Path_right.svg": "6362",
	"./Path_up.svg": "d697",
	"./Search_icon.svg": "f498",
	"./Sent.svg": "a565",
	"./Vector.svg": "b012",
	"./account_statement.svg": "19c8",
	"./add.svg": "b3c0",
	"./add_icon-2.svg": "9479",
	"./add_icon.svg": "c189",
	"./agents.svg": "5296",
	"./alert.svg": "4c89",
	"./alert_circle.svg": "409d",
	"./amount-rounded.svg": "d824",
	"./amt_received.svg": "8be5",
	"./award.svg": "e005",
	"./backspace.svg": "6d34",
	"./bank.svg": "ccc1",
	"./buy_airtime.svg": "5b9b",
	"./cable-images.svg": "3329",
	"./cable-tv.svg": "bd52",
	"./calendar-rounded.svg": "1e9e",
	"./card.svg": "af81",
	"./caret-down.svg": "dc4ae",
	"./check-blue.svg": "7aef",
	"./check.svg": "4a24",
	"./chev-left.svg": "70db",
	"./chev-right.svg": "feda",
	"./close-icon-light.svg": "7e39",
	"./close-icon.svg": "536d",
	"./close.svg": "bb7c",
	"./close_btn.svg": "aa31",
	"./complete_count.svg": "dea9",
	"./copy.svg": "b420",
	"./credit_card.svg": "bb49",
	"./digitalGoods/airtel_logo.svg": "4803",
	"./digitalGoods/glo_logo.svg": "dae1",
	"./digitalGoods/mtn_logo.svg": "b556",
	"./digitalGoods/nine_mobile_logo.svg": "ef77",
	"./document-icon.svg": "2802",
	"./down_arrow.svg": "5110",
	"./dstv.svg": "2fb4",
	"./edit.svg": "2dd2",
	"./email1.svg": "c810",
	"./empty-box.svg": "7497",
	"./emptylist.svg": "e624",
	"./error.svg": "ec4e",
	"./exclamation.svg": "43d3",
	"./eye-closed.svg": "8fb5",
	"./eye-open.svg": "8468",
	"./failed.svg": "1ad9",
	"./fixed.svg": "e888",
	"./fixedaccount.svg": "c882",
	"./flexible.svg": "8a2b",
	"./gift.svg": "6953",
	"./grow-with-traction.svg": "5acf",
	"./handshake.svg": "d9c9",
	"./home-pos-image.png": "0f04",
	"./homepage-get-loan.png": "c71c",
	"./house.svg": "b1ac",
	"./houseactive.svg": "ce8f",
	"./houseactivetwo.svg": "f4cb",
	"./icon-home-fixed-account.svg": "c564",
	"./icon-wallet.svg": "6b7e",
	"./incomplete_count.svg": "5eb3",
	"./info.svg": "69d9",
	"./internet-images.svg": "988b",
	"./internet.svg": "49b7",
	"./invoices.svg": "f5b4",
	"./kyc-check-green.svg": "93e2",
	"./laptop.svg": "2fdb",
	"./loadmoney.svg": "b41b",
	"./loan-landing.svg": "3000",
	"./loanitem.svg": "3261",
	"./location-marker.svg": "09ea",
	"./location.svg": "4093",
	"./logo_blank.svg": "b340",
	"./make_transfer.svg": "52ba",
	"./mastercard.svg": "0be0",
	"./minus.svg": "2aeb",
	"./minus_light.svg": "0359",
	"./mobile.svg": "b9f8",
	"./more-horizontal.svg": "2ac7",
	"./no-data.svg": "feb8",
	"./note.svg": "7e3c",
	"./offline.svg": "acfb",
	"./online.svg": "82c3",
	"./onlineOrders.svg": "f689",
	"./otherLogo.svg": "1ff9",
	"./otp-icon.svg": "93cc",
	"./pay-method-rounded.svg": "fc9e",
	"./pay_date.svg": "f480",
	"./pay_method.svg": "f441",
	"./payment-icon.svg": "e85a",
	"./paymentMethod/bank.svg": "1eb0",
	"./paymentMethod/cash.svg": "5f0f",
	"./paymentMethod/dynamic.svg": "6ee9",
	"./paymentMethod/fixed.svg": "9c21",
	"./paymentMethod/online.svg": "af50",
	"./paymentMethod/pos.svg": "6e00",
	"./payoutalert.svg": "e68e",
	"./pending.svg": "4902",
	"./phone.svg": "1f9a",
	"./piggy.svg": "5c07",
	"./pin-management/business-settlement-icon.svg": "08ee",
	"./pin-management/chevron-icon-right.svg": "2040",
	"./pin-management/info-icon.svg": "204c",
	"./pin-management/settlement-pref.svg": "a27a",
	"./pin-management/store-settlement-icon.svg": "e001",
	"./pin-management/success-icon.svg": "cebb",
	"./placeholder.svg": "1311",
	"./plus.svg": "4eb1",
	"./plus_light.svg": "42c6",
	"./pointOfSale.svg": "4f59",
	"./pos-group.svg": "3065",
	"./product-options-example.svg": "1113",
	"./product-variants-example.svg": "64c0",
	"./product_bulk_upload_note.svg": "e0cc",
	"./rate.svg": "2e1f",
	"./receipt-icon-rounded.svg": "f0d0",
	"./receipt.svg": "12bf",
	"./requestpos.svg": "6cde",
	"./roles-icon.svg": "7099",
	"./round-icon-bg.svg": "697b",
	"./routes/businessServices/account.svg": "de05",
	"./routes/businessServices/creditBook.svg": "17f6",
	"./routes/businessServices/customers.svg": "74f9",
	"./routes/businessServices/insights.svg": "52c4",
	"./routes/businessServices/invoices.svg": "65ff",
	"./routes/businessServices/loans.svg": "f054",
	"./routes/businessServices/sales.svg": "a9a3",
	"./routes/businessServices/tickets.svg": "c5b2",
	"./routes/businessServices/transactions.svg": "e181",
	"./routes/businessServices/wallet.svg": "e278",
	"./routes/onlineStore/onlineCatalog.svg": "909e",
	"./routes/onlineStore/onlineOrders.svg": "1062",
	"./routes/profile/businessProfile.svg": "cf02",
	"./routes/profile/manageUsers.svg": "e48b",
	"./routes/retailStore/inventoryManagement.svg": "55ae",
	"./routes/retailStore/myProducts.svg": "250c",
	"./routes/retailStore/pointOfSale.svg": "40f2",
	"./routes/retailStore/printLabel.svg": "a51f",
	"./routes/retailStore/registers.svg": "4b12",
	"./routes/settings/hardwareSettings.svg": "3cd3",
	"./routes/settings/notificationSettings.svg": "629d",
	"./routes/settings/settlementSettings.svg": "4a0f",
	"./routes/settings/syncing.svg": "eb32",
	"./routes/settings/wallet.svg": "f681",
	"./routes/support/aboutUs.svg": "3d63",
	"./routes/support/customerCare.svg": "f03e",
	"./routes/support/terms.svg": "994a",
	"./sales-icon.svg": "024f",
	"./sales.svg": "cc47",
	"./search-icon-black.svg": "5647",
	"./shop-sign-bag.svg": "80fe",
	"./shop.svg": "e158",
	"./smartcredit.svg": "1441",
	"./success-2.svg": "6a49",
	"./success.svg": "b235",
	"./syncidle.svg": "d27e",
	"./syncing.svg": "0d2d",
	"./term.svg": "ff9b",
	"./terminal.svg": "a8a4",
	"./tick.svg": "5797",
	"./tiny-plus-bold.svg": "464d",
	"./toggle-left-off.svg": "c66a",
	"./toggle-left.svg": "f022",
	"./toggle-right.svg": "69a3",
	"./traction_wallet_transaction_receipt_logo.svg": "8f6b",
	"./trans.svg": "8f40",
	"./trans_type.svg": "0f36",
	"./transactions.svg": "ce30",
	"./trash-2.svg": "b81f",
	"./trash.svg": "9961",
	"./tv.svg": "65f9",
	"./unlock.svg": "a13c",
	"./upload-icon-up.svg": "1438",
	"./users-icon.svg": "695b",
	"./utilities-images.svg": "f3d2",
	"./utilities.svg": "a49c",
	"./visa.svg": "4c1f1",
	"./visibility_icon.svg": "c55e",
	"./wallet-copy-clipboard.svg": "abe9",
	"./wallet.svg": "d45e",
	"./wallet/9mobile_logo.svg": "2d6b",
	"./wallet/airtel_logo.svg": "8902",
	"./wallet/glo_logo.svg": "5b8e",
	"./wallet/globe.svg": "858f",
	"./wallet/more_vert.svg": "89c7",
	"./wallet/mtn_logo.svg": "927b",
	"./wallet/success_check.svg": "a5bd",
	"./wallet/success_logo.svg": "d6f5",
	"./wallet/tablet.svg": "3533",
	"./wallet_house.svg": "3d1b",
	"./warning_amber.svg": "c4cf",
	"./warning_otp.svg": "5065",
	"./wrong-otp.svg": "7704"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46f5";